/* istanbul ignore file */

const RECONNECTION_RETRY_DURATION_IN_MINUTES = process.env.RECONNECTION_RETRY_TIME_IN_MINUTES
  ? parseInt(process.env.RECONNECTION_RETRY_TIME_IN_MINUTES)
  : 3;

export const RECONNECTION_RETRY_TIME = RECONNECTION_RETRY_DURATION_IN_MINUTES * 60 * 1000;
export const CACHE_STATUS_EXPIRED = 'expired';
export const CACHE_STATUS_FRESH = 'fresh';
